var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkHigh = function SvgNetworkHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 700"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "network-high_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    fill: "#fff",
    d: "M0 0h550v700H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#network-high_svg__a)",
    fill: "#1acc8d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M450 0a49.847 49.847 0 0 0-50 50v600a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50V50a49.847 49.847 0 0 0-50-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M250 150a49.847 49.847 0 0 0-50 50v450a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50V200a49.847 49.847 0 0 0-50-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M50 300a49.847 49.847 0 0 0-50 50v300a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50V350a49.847 49.847 0 0 0-50-50Z"
  }))));
};
export default SvgNetworkHigh;